import type { QueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { FullScreenLoader } from '@/components/loaders/full-screen-loader';
import { CommentatorsLayout } from '@/components/ui/layouts/commentators-layout';
import {
  getCourtsQueryOptions,
  useCourts,
} from '@/features/courts/api/get-courts';
import { useDivisions } from '@/features/divisions/api/get-divisions';

export const courtsLoader = (queryClient: QueryClient) => async () => {
  const query = getCourtsQueryOptions();

  return (
    queryClient.getQueryData(query.queryKey) ??
    (await queryClient.fetchQuery(query))
  );
};

export const CommentatorsCourtsPage = () => {
  const divisionsQuery = useDivisions();
  const courtsQuery = useCourts();

  if (divisionsQuery.isLoading || courtsQuery.isLoading) {
    return <FullScreenLoader />;
  }

  if (!divisionsQuery.data || !courtsQuery.data) {
    return null;
  }

  const { divisions } = divisionsQuery.data;
  const { courts } = courtsQuery.data;

  return (
    <CommentatorsLayout courts={courts} divisions={divisions}>
      <div className="mt-10 text-gray-700 dark:bg-gray-50">
        <div className="mb-6">
          <h2 className="text-2xl font-bold">Courts</h2>
          <p className="text-lg text-gray-600">
            Select a court to view lineups
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4">
          {courts.map((court) => (
            <Link
              key={court.id}
              to={`/commentators/courts/${court.id}/lineups`}
              className="rounded-lg border border-gray-200 p-8 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800"
            >
              <div className="text-lg font-semibold">{court.name}</div>
              {court.active_match ? (
                <div className="mt-2 text-sm text-gray-600">
                  {court.active_match.label}
                </div>
              ) : (
                <div className="mt-2 text-sm text-gray-400">
                  No active match
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
    </CommentatorsLayout>
  );
};
